/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowThread200ResponseDataCategory
 */
export interface ShowThread200ResponseDataCategory {
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseDataCategory
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataCategory
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataCategory
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataCategory
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowThread200ResponseDataCategory
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataCategory
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowThread200ResponseDataCategory
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowThread200ResponseDataCategory interface.
 */
export function instanceOfShowThread200ResponseDataCategory(value: object): value is ShowThread200ResponseDataCategory {
    return true;
}

export function ShowThread200ResponseDataCategoryFromJSON(json: any): ShowThread200ResponseDataCategory {
    return ShowThread200ResponseDataCategoryFromJSONTyped(json, false);
}

export function ShowThread200ResponseDataCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowThread200ResponseDataCategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'description': json['description'] == null ? undefined : json['description'],
        'position': json['position'] == null ? undefined : json['position'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowThread200ResponseDataCategoryToJSON(json: any): ShowThread200ResponseDataCategory {
    return ShowThread200ResponseDataCategoryToJSONTyped(json, false);
}

export function ShowThread200ResponseDataCategoryToJSONTyped(value?: ShowThread200ResponseDataCategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'slug': value['slug'],
        'description': value['description'],
        'position': value['position'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

